var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.has_clock > 0)?_c('router-link',{staticClass:"daka_index_btn",attrs:{"to":"/main/daka_action","tag":"div"}},[_c('img',{staticClass:"clock-in",attrs:{"src":require("@/assets/img/daka/daka_icon2.png")}}),_c('p',[_vm._v(_vm._s(_vm.$t("index.signin")))]),_c('div',{staticClass:"red_point"})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }